import React from "react";

import { Form, Input, InputNumber, Radio, Row } from "antd";

const CooperateFeeComponent = ({ cooperate, setCooperate }) => {
  // const handleCooperateFee = (e) => {
  // 	const { value, name } = e.target;
  // 	setCooperate({
  // 		...cooperate,
  // 		[name]: value,
  // 	});
  // };

  return (
    <>
      <Row
        className="product-register-border-box"
        wrap={false}
        style={{ marginTop: 20 }}
      >
        <span className="product-register-box-title">
          리워드 <span style={{ fontSize: "0.8em" }}>(매출 연동 수수료)</span>
        </span>
      </Row>
      <Row
        className="product-register-border-box"
        wrap={false}
        style={{ borderTop: 0, width: "100%", gap: "1rem" }}
      >
        <Form.Item style={{ margin: 0, width: 100 }} wrapperCol={{ span: 22 }}>
          <div
            className="product-option-row-wrap"
            style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
          >
            <InputNumber
              type="number"
              name="commission_rate"
              value={cooperate.commission_rate}
              min={0}
              max={100}
              onChange={(value) => {
                if (value > 0 && value <= 100) {
                  setCooperate({ ...cooperate, commission_rate: value });
                }
              }}
            />
            <span className="product-price-label">%</span>
          </div>
        </Form.Item>
        <Radio
          className={`category`}
          checked={cooperate.dy_commision_include}
          onClick={() =>
            setCooperate({
              ...cooperate,
              dy_commision_include: !cooperate.dy_commision_include,
            })
          }
        >
          당영 관리 수수료 <span style={{ fontSize: "0.8em" }}>(10%)</span>
        </Radio>
      </Row>
    </>
  );
};

export default CooperateFeeComponent;
